module.exports = __webpack_public_path__ + "static/media/support.bdd8767e.svg";